import { useEffect, useState } from 'react';
import { createPaymentLink, quotePaymentLink, sendPaymentLink } from '../models/paymentsV2Model';
import { decimal, positiveAmount } from '../utilities/paymentPresentation';
import { usePaymentCommand } from './usePaymentCommand';
export const LINK_OUTCOMES = {
  active_sent: 'Link created; sharing accepted—not proof of delivery', active: 'Link ready', active_send_failed: 'Link created, sending failed',
  activation_failed_released: 'The provider refused the link. Nothing was reserved; you can try again.',
  activation_ambiguous: "The provider didn't confirm. Accounts must check this link before a new one is made.",
  configuration_missing: 'Payment provider not configured. Ask an admin.',
};
export function usePaymentLinkForm(queryPk, values, reload) {
  const [quote, setQuote] = useState(null);
  const [quoteError, setQuoteError] = useState(null);
  const [quoting, setQuoting] = useState(false);
  const command = usePaymentCommand(`payment-link-${queryPk}`, () => reload({ silent: true }));
  const resend = usePaymentCommand(`link-send-${queryPk}`, () => reload({ silent: true }));
  useEffect(() => {
    let active = true; setQuote(null); setQuoteError(null);
    if (!positiveAmount(values.amount)) { setQuoting(false); return undefined; }
    setQuoting(true);
    const timer = setTimeout(() => quotePaymentLink(queryPk, values.provider_name || 'network', decimal(values.amount), values.settlement_arrangement_id)
      .then(next => { if (active) setQuote(next); }).catch(error => { if (active) setQuoteError(error); }).finally(() => { if (active) setQuoting(false); }), 400);
    return () => { active = false; clearTimeout(timer); };
  }, [queryPk, values.provider_name, values.amount, values.settlement_arrangement_id]);
  return { ...command, quote, quoteError, quoting, resend,
    create: values => command.submit(payload => createPaymentLink(queryPk, payload), {
      provider_name: values.provider_name, amount: decimal(values.amount), settlement_arrangement_id: values.settlement_arrangement_id || null,
      ...(values.sharing === 'auto' ? { send: { channel: 'auto' } } : values.sharing === 'record_only' ? { send: { channel: 'record_only', record_only_reason: values.record_only_reason?.trim() } } : {}),
    }),
    send: () => resend.submit(payload => sendPaymentLink(command.result.intent.id, payload), { channel: 'auto' }),
  };
}
